@if (usersLoading()) {
  <div class="flex justify-center p-4">
    <mat-spinner></mat-spinner>
  </div>
} @else if (usersError()) {
  <div class="flex justify-center p-4">
    <p class="text-red-500">{{ errorText }}</p>
  </div>
} @else {
  <div class="overflow-x-auto">
    <table
      mat-table
      [dataSource]="dataSource"
      [matSortActive]="currentSort.active"
      [matSortDirection]="currentSort.direction"
      matSort
      (matSortChange)="sortData($event)"
      class="w-full"
    >
      <!-- Name Column -->
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
          Name
        </th>
        <td mat-cell *matCellDef="let user" class="border-b p-4">
          {{ user.name }}
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
          Email
        </th>
        <td mat-cell *matCellDef="let user" class="border-b p-4">
          {{ user.email }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24">
          <!-- Empty header for actions column -->
        </th>
        <td mat-cell *matCellDef="let user" class="border-b p-4 text-right">
          <div class="invisible group-hover:visible flex items-center gap-2">
            <button
              *ngIf="!isAdmin()"
              mat-icon-button
              matTooltip="Archive User"
              (click)="openArchiveDialog(user); $event.stopPropagation()"
              class="text-gray-700"
            >
              <mat-icon>archive</mat-icon>
            </button>
            <button
              *ngIf="!isAdmin()"
              mat-icon-button
              matTooltip="Edit User"
              (click)="editUser(user); $event.stopPropagation()"
              class="text-gray-700"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="viewUserDetails(row)"
        class="hover:bg-gray-100 cursor-pointer user-row group"
      ></tr>
    </table>
  </div>

  <ciwc-pagination
    [currentPage]="pageIndex"
    [pageSize]="pageSize"
    [totalItems]="totalUsers"
    [pageSizeOptions]="pageSizeOptions"
    (pageChange)="handlePageEvent($event)"
  ></ciwc-pagination>

  <!-- Hidden paginator for functionality -->
  <div class="hidden">
    <mat-paginator
      #paginator
      [length]="totalUsers"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="handlePageEvent($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
}
